import React from 'react';

// Continue-with-Google button. Kicks off the Emergent-managed Google
// OAuth flow by redirecting the browser to auth.emergentagent.com with
// our callback URL as the `redirect` query param. Emergent handles the
// Google consent screen, then redirects back to `/auth/callback` with
// `#session_id=XXX` in the URL fragment. AuthCallback.js exchanges
// that session_id with our backend (`/api/auth/google`) for a JWT
// cookie.
//
// REMINDER (from Emergent playbook): DO NOT hardcode the URL or add
// any fallback/redirect overrides — Emergent's auth gateway validates
// the redirect against the originating window.location.origin and
// will fail otherwise.
export default function GoogleSignInButton({ label = 'Continue with Google', testId = 'google-signin' }) {
  const handleClick = () => {
    const callback = `${window.location.origin}/auth/callback`;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(callback)}`;
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      data-testid={testId}
      className="w-full flex items-center justify-center gap-3 py-2.5 px-4 rounded-md border border-[var(--border-medium)] bg-[var(--background-elevated)] hover:bg-[var(--hover-bg)] text-[var(--text-primary)] font-medium transition-colors"
    >
      <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
        <path fill="#4285F4" d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 01-1.796 2.716v2.259h2.908c1.702-1.567 2.684-3.875 2.684-6.615z"/>
        <path fill="#34A853" d="M9 18c2.43 0 4.467-.806 5.956-2.184l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 009 18z"/>
        <path fill="#FBBC05" d="M3.964 10.706A5.41 5.41 0 013.682 9c0-.593.102-1.17.282-1.706V4.962H.957A8.997 8.997 0 000 9c0 1.452.348 2.827.957 4.038l3.007-2.332z"/>
        <path fill="#EA4335" d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 00.957 4.962L3.964 7.294C4.672 5.167 6.656 3.58 9 3.58z"/>
      </svg>
      <span>{label}</span>
    </button>
  );
}
